import { ElementRef, EventEmitter } from '@angular/core';
import { GenericAction } from '@com-delta-omnichannel/mach';
import * as Constants from './models/predictive-search.constants';
import { PredictiveSearch } from './models/predictive-search.interfaces';
import { PredictiveSearchAccessibility } from './predictive-search.accessibility';

export class PredictiveSearchExtended {
  accessibility!: PredictiveSearchAccessibility;
  searchInput!: ElementRef<HTMLInputElement>;
  content = {} as PredictiveSearch;
  menuWidth = 220;
  searchText = '';
  activeOptionIndex = -1;
  isDropdownOpen = false;
  selectedOption!: GenericAction;
  customWidth = 'auto';
  isFocused = false;
  hasError = false;
  choose!: EventEmitter<GenericAction>;
  valueChange!: EventEmitter<string>;
  isMenuExpanded!: EventEmitter<boolean>;

  onChange: (value: string) => void = () => {
    // Initialized empty
  };

  onTouched: () => void = () => {
    // Initialized empty
  };

  clearSearchText() {
    this.searchText = '';
    this.content.items = [];
    this.hasError = false;
    this.searchInput?.nativeElement?.focus?.();
    this.valueChange.emit(this.searchText);
    this.onChange(this.searchText);
  }

  openDropdown(): void {
    const inputWidth = this.searchInput.nativeElement.offsetWidth;
    this.customWidth = `${Math.max(this.menuWidth, inputWidth)}px`;
    this.valueChange.emit(this.searchText);
    this.onChange(this.searchText);
    if (this.searchText.length > 2) this.isDropdownOpen = true;
  }

  closeDropdown(): void {
    this.isDropdownOpen = false;
    this.activeOptionIndex = -1;
    this.accessibility.reset();
    this.isMenuExpanded.emit(false);
  }

  onFocusIn(value: string) {
    if (value === 'ONFOCUS') this.openDropdown();
    this.isFocused = true;
    this.content.placeholder =
      value === `${Constants.EVENT_TYPES}` ? '' : this.content.placeholder;
  }

  onFocusOut(event: FocusEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;
    this.isFocused = false;
    this.onTouched();
    if (relatedTarget && relatedTarget.closest('.predictive-search__list')) {
      return;
    }
    this.activeOptionIndex = -1;
    this.accessibility.reset();
  }

  writeValue(value: string): void {
    this.searchText = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.searchInput?.nativeElement) {
      this.searchInput.nativeElement.disabled = isDisabled;
    }
  }
}
